module.exports = __webpack_public_path__ + "static/img/shujufenxi.ddfea280.jpeg";